<template>
  <v-container>
    <v-card class="elevation-15 rounded-lg">
      <v-row justify="start" class="mt-0 ms-n5" v-if="authStore.user">
        <v-col cols="12" md="12">
          <v-card elevation="10">
            <v-card-title class="bg-pink white--text d-flex align-center">
              <v-icon class="mr-2" color="white">mdi-chart-line</v-icon>
              สถิติ ผลการเรียน PLO (Program Learning Outcomes)
            </v-card-title>
            <v-card-title>
              <v-spacer class="mt-5"></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-row align="center">
                <v-col cols="12" md="3">
                  <v-select v-model="reqReport.enrollYear" label="เลือกรหัสนักศึกษา" :items="studentPrefixOption"
                    variant="outlined" item-title="text" item-value="value"></v-select>
                </v-col>

                <v-col cols="12" md="2">
                  <v-select v-model="reqReport.ploNumber" label="ตัวเลือก PLO" :items="ploOption" variant="outlined"
                    item-title="text" item-value="value"></v-select>
                </v-col>

                <v-col cols="12" md="2" class="mb-6 ms-n5">
                  <v-fade-transition>
                    <v-btn prepend-icon="mdi-magnify-expand" color="blue-darken-1 elevation-15" @click="fetchReport">
                      ค้นหา
                    </v-btn>
                  </v-fade-transition>
                </v-col>
                <v-col cols="12" md="2" class="mb-6 ms-n5">
                  <v-fade-transition>
                    <v-btn v-if="result.studentsWithPLOData > 0" prepend-icon="mdi-close-circle-outline"
                      color="red-darken-1 elevation-15" @click="clearReportReq">
                      ล้างข้อมูล
                    </v-btn>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </v-card-text>
            <transition name="slide-y-transition" mode="out-in">
              <v-card-text class="pa-4" v-if="result.studentsWithPLOData > 0">
                <v-card variant="flat" class="mb-4">
                  <v-card-title class="text-subtitle-1 text-sm-h6 font-weight-medium bg-grey-lighten-4">
                    <div class="d-flex align-center w-100">

                      <div class="flex-grow-1">
                        <!-- <div class="text-subtitle-1 font-weight-bold">
                          ปีการศึกษา {{ result.ploAssessmentYear }}
                        </div> -->
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text class="pa-4">
                    <v-card variant="elevated">
                      <v-card-title class="text-subtitle-1 text-sm-h6 font-weight-medium bg-grey-lighten-4">
                        <div class="d-flex align-center w-100">
                          <v-icon class="mr-3" color="primary">mdi-chart-bar</v-icon>
                          <div class="flex-grow-1">
                            <div class="text-subtitle-1 font-weight-bold">
                              {{ result.ploKey }}
                            </div>
                          </div>
                        </div>
                      </v-card-title>

                      <v-card-text class="pa-0 mt-2">
                        <div v-if="!result.subjects || Object.keys(result.subjects).length === 0"
                          class="text-center pa-4 text-grey text-h6">
                          ยังไม่มีข้อมูลในระบบ
                        </div>
                        <v-list v-else class="text-left" lines="one">
                          <v-list-item v-for="(item, subjectKey) in result.subjects" :key="subjectKey"
                            @click="viewStudent(item)">
                            <v-list-item-title class="font-weight-medium">
                              {{ subjectKey }}
                            </v-list-item-title>
                            <div class="text-caption text-medium-emphasis">
                              ไม่ผ่าน {{ item.notPassCount }} คน
                              (คลิกเพื่อดูรายชื่อ)
                              {{
                                item.noDataCount
                                  ? `${item.noDataCount} คน ไม่มีข้อมูล`
                                  : ""
                              }}
                            </div>
                            <template v-slot:append>
                              <div class="text-right">
                                <span class="text-subtitle-1 font-weight-bold">
                                  {{ item.passPercentage }}
                                </span>
                                <div class="text-caption text-medium-emphasis">
                                  นับเป็น {{ item.passCount }} คน จาก
                                  {{
                                    item.passCount +
                                    item.notPassCount +
                                    item.noDataCount
                                  }}
                                  คน
                                </div>
                              </div>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </transition>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="detailDialog" max-width="900px">
      <v-card class="rounded-lg">
        <v-card-title class="bg-blue-darken-1 white--text d-flex align-center">
          <v-icon class="mr-2">mdi-account-group</v-icon>
          รายชื่อนักศึกษาที่ไม่ผ่าน
          <v-spacer></v-spacer>
          <v-btn icon="mdi-close" variant="text" @click="detailDialog = false"></v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-table hover density="comfortable">
            <thead>
              <tr>
                <th class="text-left font-weight-bold">ลำดับ</th>
                <th class="text-left font-weight-bold">รหัสนักศึกษา</th>
                <th class="text-left font-weight-bold">ชื่อ-นามสกุล</th>
                <td class="text-left font-weight-bold">ผล</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in studentList" :key="student.studentNum">
                <td>{{ index + 1 }}</td>
                <td>{{ student.studentNum }}</td>
                <td>{{ student.displayName }}</td>
                <td>
                  <v-chip :color="getStatusColor(student.ploResult)" class="ma-0" text-color="white">
                    {{ student.ploResult }}
                  </v-chip>
                </td>
              </tr>

              <tr v-if="studentList.length === 0">
                <td colspan="3" class="text-center pa-4 text-grey">
                  ไม่พบข้อมูล
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-darken-1" variant="tonal" @click="detailDialog = false">
            ปิดหน้าต่าง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import {
  ref,
  onMounted,
  watch,
  computed,
  watchEffect,
  getCurrentInstance,
} from "vue";
import { useAuthStore } from "@/stores/auth";
import axios from "axios";

const { proxy } = getCurrentInstance();
const authStore = useAuthStore();

const searchOption = ref("studentNum");
const option = ref([
  { text: "รหัสนักศึกษา", value: "studentNum" },
  { text: "ชื่อ-นามสกุล นักศึกษา", value: "displayName" },
]);
const result = ref([]);
const loading = ref(false);
const searchReq = ref("");
const searchTimeoutId = ref(null);
const totalItems = ref(0);
const detailDialog = ref(false);
const selectedStudent = ref(null);
const addStudentDialog = ref(null);
const file = ref(null);
const confirmCSV = ref(false);
const studentPrefixOption = ref([]);
const studentList = ref([]); // Store students for the modal

const currentYear = new Date().getFullYear() + 543;
const dynamicYear = (yearBefore, yearAfter) => {
  const currentAcademicYear = currentYear; // Academic year is next year
  const years = [];
  for (let i = -yearBefore; i <= yearAfter; i++) {
    years.push((currentAcademicYear + i).toString());
    studentPrefixOption.value.push({
      text: (currentAcademicYear + i).toString().slice(2),
      value: (currentAcademicYear + i).toString(),
    });
  }
  return years;
};

watchEffect(() => {
  if (studentPrefixOption.value.length == 0) {
    dynamicYear(6, 3);
  }
});

const ploOption = ref([1, 2, 3, 4, 5, 6, 7, 8]);

const now = new Date();
const reqReport = ref({
  enrollYear: (now.getFullYear() + 543).toString() || "",
  ploNumber: "1" || "",
});

const clearReportReq = () => {
  result.value = [];
};

watch(searchReq, (newValue) => {
  if (searchTimeoutId.value) {
    clearTimeout(searchTimeoutId.value);
  }

  searchTimeoutId.value = setTimeout(() => {
    if (newValue) {
      // fetchStudents(); // Assuming this is defined elsewhere or meant to be fetchReport
    }
  }, 500);
});

const yearOption = ["ปี 1", "ปี 2", "ปี 3", "ปี 4"];

const tableOptions = ref({
  page: 1,
  itemsPerPage: 10,
  sortBy: [],
  sortDesc: [],
  multiSort: false,
  search: "",
  searchType: "displayName",
});

const TOKEN = authStore.getBackendJwt();

const headers = ref([
  { title: "Student ID", key: "studentNum", sortable: false },
  { title: "Name", key: "displayName", sortable: false },
  { title: "Actions", key: "actions", sortable: false, width: "350px" },
]);

const fetchReport = async () => {
  result.value = [];
  authStore.loading = true;
  try {
    const response = await axios.get(
      `/api/Report?enrollGroup=${reqReport.value.enrollYear}&ploNumber=${reqReport.value.ploNumber}`,
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 403 ||
            status === 401
          );
        },
      },
    );

    const data = response.data;
    result.value = data.data;

    if (response.status === 403 || response.status === 401) {
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Invalid Operation",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container",
        },
      });
    } else if (
      response.status === 200 &&
      result.value.studentsWithPLOData === 0
    ) {
      await proxy.$swal({
        title: "Error!",
        text:
          response.data?.message ||
          `ไม่พบข้อมูล PLO${reqReport.value.ploNumber} สำหรับรหัสนักศึกษา ${reqReport.value.enrollYear}`,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container",
        },
      });
    }
  } catch (error) {
    console.error("Error fetching students:", error);
    result.value = [];
  } finally {
    authStore.loading = false;
  }
};

const viewStudent = async (student) => {
  console.log("Viewing student: PLO.", student.ploLabel);
  try {
    authStore.loading = true;
    const response = await axios.get(
      `/api/plo-list?ploYear=${student.ploYear}&ploKey=${student.ploKey}&ploSubject=${student.ploSubject}&enrollYear=${reqReport.value.enrollYear}`,
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 403 ||
            status === 401
          );
        },
      },
    );

    if (
      response.data &&
      response.data.success &&
      response.data.data.length > 0
    ) {
      studentList.value = response.data.data;
      detailDialog.value = true;
    } else {
      await proxy.$swal({
        title: "ไม่พบข้อมูล",
        text: `ไม่พบข้อมูลรายชื่อนักศึกษาที่ไม่ผ่าน ${student.ploLabel || student.ploKey
          }`,
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container",
        },
      });
    }
  } catch (error) {
    console.error("Error fetching student details:", error);
    proxy.$swal({
      title: "Error!",
      text: "ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
      icon: "error",
    });
  } finally {
    authStore.loading = false;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const getStatusColor = (status) => {
  const passStatus = ["pass", "ผ่าน"];
  const notPassStatus = ["not pass", "ไม่ผ่าน"];
  switch (status?.toLowerCase()) {
    case passStatus.includes(status?.toLowerCase()) ? status.toLowerCase() : "":
      return "success";
    case notPassStatus.includes(status?.toLowerCase())
      ? status.toLowerCase()
      : "":
      return "error";
    case "pending":
      return "warning";
    case "in progress":
      return "warning";
    default:
      return "success";
  }
};

const confirmupload = () => {
  proxy
    .$swal({
      title: `คุณมั่นใจในการอัปโหลดข้อมูล ใช่หรือไม่?`,
      showDenyButton: true,
      confirmButtonText: "ยืนยัน",
      denyButtonText: `ยกเลืก`,
      customClass: {
        container: "my-swal-container",
      },
    })
    .then((result) => {
      if (result.isConfirmed) {
        fileupload();
      }
    });
};

const fileupload = async () => {
  if (!file.value) {
    proxy.$swal({
      title: "เกิดข้อผิดพลาด",
      text: ` NO file selected`,
      icon: "error",
      timer: 2000,
      customClass: {
        container: "my-swal-container",
      },
    });
    return;
  }
  try {
    authStore.loading = true;
    const formData = new FormData();
    formData.append("file", file.value);
    const response = await axios.post(`/api/AddStudentCSV`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${TOKEN}`,
      },
      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 401 ||
          status === 403
        );
      },
    });
    if (response.status === 200) {
      proxy.$swal({
        title: "อัปโหลดสำเร็จ!",
        text: "Upload CSV file successfully!! ",
        icon: "success",
        timer: 2000,
        customClass: {
          container: "my-swal-container",
        },
      });
      file.value = null;
      confirmCSV.value = false;
    } else if (response.status === 500) {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` ${response.data.message}`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container",
        },
      });
    } else if (response.status === 401 || response.status === 403) {
      // Assuming you have router defined somewhere globally or need to import useRouter
      // router.push("/");
    } else {
      proxy.$swal({
        title: "เกิดข้อผิดพลาด",
        text: ` An unexpected error occurred.`,
        icon: "error",
        timer: 2000,
        customClass: {
          container: "my-swal-container",
        },
      });
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("Error processing file. Check the console for details.");
  } finally {
    authStore.loading = false;
  }
};
</script>

<style scoped>
.v-data-table {
  min-height: 400px;
}

.v-skeleton-loader {
  margin: 16px;
}
</style>
